module.exports = __webpack_public_path__ + "honor-certificate-01.jpg?a32d6cab30a61a636d388acb2a8e6f91";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pc/honor-certificate-01.jpg
// module id = 151
// module chunks = 0